import { adminService } from '@/api/services';
import type { UnwrapData } from '@/api/types';

import type { IAboutBankResponse, TAboutBankPayload } from './types';

export const aboutBankService = adminService.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Получить данные блока "О ПСБ"
     */
    getAboutBank: builder.query<UnwrapData<IAboutBankResponse>, { id: number }>({
      query: ({ id }) => ({
        method: 'GET',
        url: `/main_pages/${id}/about_bank`,
      }),
      transformResponse: (response: IAboutBankResponse): UnwrapData<IAboutBankResponse> => response.data,
      providesTags: ['MainPageAboutBank'],
    }),
    /**
     * Создать данные блока "О ПСБ"
     */
    createAboutBank: builder.mutation<UnwrapData<IAboutBankResponse>, { id: number; data: TAboutBankPayload }>({
      query: ({ id, data }) => ({
        method: 'POST',
        url: `/main_pages/${id}/about_bank`,
        body: {
          data,
        },
      }),
      transformResponse: (response: IAboutBankResponse): UnwrapData<IAboutBankResponse> => response.data,
      invalidatesTags: ['MainPage', 'MainPageAboutBank'],
    }),
    /**
     * Обновить данные блока "О ПСБ"
     */
    updateAboutBank: builder.mutation<UnwrapData<IAboutBankResponse>, { id: number; data: TAboutBankPayload }>({
      query: ({ id, data }) => ({
        method: 'PATCH',
        url: `/main_pages/${id}/about_bank`,
        body: {
          data,
        },
      }),
      transformResponse: (response: IAboutBankResponse): UnwrapData<IAboutBankResponse> => response.data,
      invalidatesTags: ['MainPageAboutBank'],
    }),
  }),
});

export const { useGetAboutBankQuery, useCreateAboutBankMutation, useUpdateAboutBankMutation } = aboutBankService;
